import {
  GeospatialHeader,
  GeospatialFiltersFab,
  GeospatialFiltersDialog,
  GeospatialMapSection,
  GeospatialInsightSection,
  useGeospatialPage,
} from '../features/geospatial-intelligence';
import '../css/geospatial-intelligence.css';

export const GeospatialIntelligence = () => {
  const geo = useGeospatialPage();

  return (
    <div className="geo-page unit-overview-container geospatial-page">
      <GeospatialHeader />

      <GeospatialFiltersFab
        open={geo.filtersOpen}
        onToggle={() => geo.setFiltersOpen(!geo.filtersOpen)}
      />

      <div className="geo-layout geospatial-split-grid" aria-label="Geospatial layout regions">
        <GeospatialMapSection
          showAllRisks={geo.showAllRisks}
          country={geo.country}
          city={geo.city}
          sourceType={geo.sourceType}
          originator={geo.originator}
          operatingMode={geo.operatingMode}
          riskCategory={geo.riskCategory}
          impactTarget={geo.impactTarget}
          publicationFromDayMs={geo.publicationFromDayMs}
          publicationToDayMs={geo.publicationToDayMs}
          unitCoverage={geo.unitCoverage}
          onRawRisksLoaded={geo.onRawRisksLoaded}
          onToggleAvailable={geo.setToggleAvailable}
          onSelectionChange={geo.setMapSelection}
        />

        <GeospatialInsightSection
          risks={geo.mapSelection.risks}
          selectedMapArea={geo.mapSelection.country}
        />
      </div>

      <GeospatialFiltersDialog
        open={geo.filtersOpen}
        onClose={() => geo.setFiltersOpen(false)}
        showAllRisks={geo.showAllRisks}
        onShowAllRisksChange={geo.onShowAllRisksChange}
        toggleDisabled={!geo.toggleAvailable}
        country={geo.country}
        onCountryChange={geo.setCountry}
        city={geo.city}
        onCityChange={geo.setCity}
        sourceType={geo.sourceType}
        onSourceTypeChange={geo.setSourceType}
        originator={geo.originator}
        onOriginatorChange={geo.setOriginator}
        operatingMode={geo.operatingMode}
        onOperatingModeChange={geo.setOperatingMode}
        riskCategory={geo.riskCategory}
        onRiskCategoryChange={geo.setRiskCategory}
        impactTarget={geo.impactTarget}
        onImpactTargetChange={geo.setImpactTarget}
        publicationFromIndex={geo.publicationFromIndex}
        publicationToIndex={geo.publicationToIndex}
        onPublicationFromIndexChange={geo.setPublicationFromIndex}
        onPublicationToIndexChange={geo.setPublicationToIndex}
        options={geo.options}
      />
    </div>
  );
};
